var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-progress-circular",
    {
      staticClass: "timer-rotate",
      attrs: {
        rotate: _vm.rotate,
        size: _vm.size,
        width: _vm.width,
        value: (_vm.current * 100) / _vm.total,
        color: _vm.color,
      },
    },
    [
      _c(
        "div",
        { attrs: { "fill-height": "", fluid: "", "grid-list-xl": "" } },
        [
          _c(
            "div",
            { attrs: { "justify-content-center": "", wrap: "" } },
            [
              _c("v-card-text", [
                _c("div", { staticClass: "timer-text" }, [
                  _c("span", { staticClass: "fw-bold timer-current-text" }, [
                    _vm._v(_vm._s(_vm.current) + "/"),
                  ]),
                  _vm._v(_vm._s(_vm.total)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "timer-text" }, [_vm._v("問目")]),
              ]),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }